import { Info } from "lucide-react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface LabelHintProps {
  text: string;
}

const LabelHint = ({ text }: LabelHintProps) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="Aide"
          className="inline-flex items-center align-middle ml-1 text-muted-foreground hover:text-card-foreground"
          onClick={(e) => e.preventDefault()}
        >
          <Info className="h-3.5 w-3.5 cursor-help" />
        </button>
      </TooltipTrigger>
      <TooltipPrimitive.Portal>
        <TooltipContent
          side="top"
          align="start"
          sideOffset={6}
          collisionPadding={12}
          className="max-w-xs"
        >
          <p className="text-xs leading-relaxed">{text}</p>
        </TooltipContent>
      </TooltipPrimitive.Portal>
    </Tooltip>
  </TooltipProvider>
);

export default LabelHint;
